class CartDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.type = "drawer"

      if(window.location.pathname != window.routes.cart_url){
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#cart-close').addEventListener('click', this.close.bind(this));
        this.addEventListener('click', this.overlayClick.bind(this));
        this.setHeaderCartIconAccessibility();
      }
    }

    overlayClick(e){
        if(e.target == this) this.close();
    }

    close() {
        this.classList.remove('cart-drawer-active');
        this.querySelector('#cart-drawer-inner').classList.remove('cart-drawer-inner-active')
        removeTrapFocus(this.activeElement);
        setTimeout(() => {
          enableScrolling();
        }, 300);
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector('#cart-icon-bubble');
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
        cartLink.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(cartLink)
        });
        cartLink.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
            this.classList.add('cart-drawer-active')
            this.querySelector('#cart-drawer-inner').classList.add('cart-drawer-inner-active')
        });
    
        this.addEventListener('transitionend', () => {
          const containerToTrapFocusOn = this.querySelector('#cart-drawer-inner');
          const focusElement = this.querySelector('#cart-drawer-inner');
          trapFocus(containerToTrapFocusOn, focusElement);
        }, { once: true });
    
        disableScrolling();
      }

      setActiveElement(element) {
        this.activeElement = element;
      }

      renderContents(parsedState) {
        const cartFooter = document.querySelector(`#${this.type}-main-cart-footer`);       
        const cartPage = document.querySelector('.main-cart-page');
        const cartItems = document.querySelector(`#${this.type}-cart-items-inner`);
        const emptyPage = document.querySelector(`#${this.type}-cart-warnings`)
     
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartPage) cartPage.classList.toggle('main-cart', parsedState.item_count !== 0);
        if (emptyPage) emptyPage.classList.toggle('is-empty', parsedState.item_count !== 0);
        if (cartItems) cartItems.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));
    
        setTimeout(() => {
          this.open();
        });
      }
    
      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
      }
    
      getSectionsToRender() {
        return [
          {
            id: `${this.type}-main-cart-items`,
            section: document.getElementById(`${this.type}-main-cart-items`).dataset.id,
            selector: '.js-contents',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section'
          },
          {
            id: `${this.type}-cart-live-region-text`,
            section: 'cart-live-region-text',
            selector: '.shopify-section'
          },
          {
            id: `${this.type}-main-cart-footer`,
            section: document.getElementById(`${this.type}-main-cart-footer`).dataset.id,
            selector: '.cart-footer-checkout',
          }
        ];
      }
    
    
  }
  
  customElements.define('cart-drawer', CartDrawer);
  